import { SystemConfigurationDto, PublicSystemConfigurationService, PublicSystemConfigurationDto } from '@/api';

export default {
  getSystemConfiguration: async (): Promise<SystemConfigurationDto> => {
    const response = await PublicSystemConfigurationService.publicSystemConfigurationControllerGetSystemConfiguration();
    return response.data;
  },

  getPublicSystemConfiguration: async (): Promise<PublicSystemConfigurationDto> => {
    const response =
      await PublicSystemConfigurationService.publicSystemConfigurationControllerGetPublicSystemConfiguration();
    return response.data;
  },

  getEnvironmentVariables: async () => {
    return PublicSystemConfigurationService.publicSystemConfigurationControllerGetEnvironmentVariables();
  },
};
